import { MainArticleData } from 'types/content-props/main-article-props';

export const mainArticleDataMock: MainArticleData = {
    ingress: '',
    text: { processedHtml: '', macros: [] },
    hasTableOfContents: 'none',
    fact: { processedHtml: '', macros: [] },
    social: [],
};
